import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { campaignsApi, type OverviewRange } from '../api/campaignsApi';
import { adsKeys } from '../queryKeys';

/**
 * Ads v9 Overview hooks. All location-scoped.
 */

export function useLatestAdsAudit() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: adsKeys.audit(locationId),
    queryFn: () => campaignsApi.audit.get(locationId),
    enabled: !!locationId,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useAdsTrend(range: OverviewRange = '30d', campaignId?: string) {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: adsKeys.trend(campaignId ?? locationId, range),
    queryFn: () =>
      campaignId
        ? // Per-campaign trend only supports the daily ranges (7d/30d/90d).
          campaignsApi.overview.campaignTrend(
            campaignId,
            (range === 'ytd' || range === '1y' ? '90d' : range) as '7d' | '30d' | '90d',
          )
        : campaignsApi.overview.trend(locationId, range),
    enabled: campaignId ? !!campaignId : !!locationId,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useWeeklySummary() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';
  return useQuery({
    queryKey: adsKeys.weeklySummary(locationId),
    queryFn: () => campaignsApi.overview.weeklySummary(locationId),
    enabled: !!locationId,
    staleTime: 10 * 60_000,
    refetchOnWindowFocus: false,
  });
}
